import React from 'react';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { HeadProvider } from 'react-head';
import configureStore from './configureStore';
import App from './components/App';

const hydrateDOM = () => {
	const { store } = configureStore(window.REDUX_STATE);

	hydrate(
		<Provider store={store}>
			<HeadProvider>
				<App />
			</HeadProvider>
		</Provider>,
		document.getElementById('root'),
	);
};

export default hydrateDOM;
